/**
 * Identity Variant Query Keys
 *
 * Centralized query key factory for a person's identity variants — the extra
 * names, addresses and holding references that supplement their base record
 * (LF-5566 PROV-21). Keyed by the polymorphic owner the backend models:
 * a matter (the flattened deceased) or a contact.
 */

export type IdentityVariantOwnerType = 'matter' | 'contact';

export const identityVariantKeys = {
  /** Root key for all identity-variant queries */
  all: ['identity-variants'] as const,

  /**
   * Every variant owned by one person
   * @param ownerType - 'matter' (the deceased) or 'contact'
   * @param ownerId - The owning matter or contact id
   */
  forOwner: (ownerType: IdentityVariantOwnerType, ownerId: number) =>
    [...identityVariantKeys.all, ownerType, ownerId] as const
} as const;
